// extracted by mini-css-extract-plugin
module.exports = {"container":"e_2q","title":"e_3q","titleIcon":"e_4q","summary":"e_5q","sourcesTitle":"e_6q","sources":"e_7q","source":"e_8q"};